<!-- =========================================================================================
	File Name: TheNavbar.vue
	Description: Navbar component
	Component Name: TheNavbar
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper w-5">
      <vs-navbar
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj"
      >
        <div class="bookmark-container flex">
          <div class="text-left leading-tight hidden sm:block">
            <p class="font-semibold">
              {{ $t("title") }} <small>{{ $t("subtitle") }}</small>
            </p>
          </div>
        </div>

        <vs-spacer></vs-spacer>
        <!-- i18n -->
        <!-- <a @click="switchLocate">
          <p class="font-semibold cursor-pointer white">{{locale}}</p>
        </a>-->
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          <span class="cursor-pointer flex i18n-locale">
            <img
              class="h-4 w-5"
              :src="require(`@/assets/images/icons/flags/${$i18n.locale}.png`)"
              :alt="$i18n.locale"
            />
            <span class="hidden sm:block ml-2">{{
              getCurrentLocaleData.lang
            }}</span>
          </span>
          <vs-dropdown-menu class="w-48 i18n-dropdown">
            <vs-dropdown-item @click="updateLocale('en')">
              <img
                class="h-4 w-5 mr-1"
                src="@/assets/images/icons/flags/en.png"
                alt="en"
              />
              &nbsp;English
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('th')">
              <img
                class="h-4 w-5 mr-1"
                src="@/assets/images/icons/flags/th.png"
                alt="th"
              />
              &nbsp;Thai
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- NOTIFICATIONS -->
        <vs-dropdown class="cursor-pointer">
          <feather-icon
            :badge="amoutNotifacation"
            icon="BellIcon"
            class="cursor-pointer sm:mr-6 mt-1 ml-5"
          ></feather-icon>
          <vs-dropdown-menu class="notification-dropdown dropdown-custom">
            <div class="notification-top text-center p-5 bg-primary text-white">
              <h3 class="text-white">10 New</h3>
              <p style="cursor: pointer" @click="markAllEventNotificationsAsRead()">Mark As Read</p>
            </div>
            <VuePerfectScrollbar
              ref="mainSidebarPs"
              class="scroll-area--nofications-dropdown p-0 mb-10"
            >
              <ul class="bordered-items">
                <li
                  v-for="event in notification.slice(0, 10)"
                  :key="event.id"
                  class="flex justify-between px-4 py-4 notification cursor-pointer"
                  @click="detailNotification(event.vessel_trip_id,event.id)"
                >
                  <div class="flex items-start">
                    <div class="mx-2">
                      <span class="font-medium block notification-title">{{
                        event.to_s
                      }}</span>
                    </div>
                  </div>

                  <small
                    v-if="event.read_at == null"
                    class="mt-1 whitespace-no-wrap"
                  >
                    {{ setDateFormat(event.updated_at) }}
                    <br />
                    <font color="red">ยังไม่อ่าน</font>
                  </small>
                  <small
                    v-else
                    class="mt-1 whitespace-no-wrap"
                    @click="detailNotification(event.vessel_trip_id,event.id)"
                  >
                    {{ setDateFormat(event.updated_at) }}
                    <br />
                    <font color="green">อ่านเเล้ว</font>
                  </small>
                </li>
              </ul>
            </VuePerfectScrollbar>
            <div
              class="checkout-footer fixed pin-b rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid border-grey-light cursor-pointer"
            >
              <router-link to="/notification">
                <span>View All Notifications</span>
              </router-link>
            </div>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- USER META -->
        <div class="the-navbar__user-meta flex items-center">
          <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ username }}</p>
            <small>Available</small>
          </div>
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
          >
            <div class="con-img ml-3">
              <vs-avatar class="medium" size="medium" :text="username" />
            </div>
            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <li
                  v-if="$acl.not.check('isAdmin')"
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/profile')"
                >
                  <feather-icon
                    icon="UserIcon"
                    svgClasses="w-4 h-4"
                  ></feather-icon>
                  <span class="ml-2">Profile</span>
                </li>
                <vs-divider
                  v-if="$acl.not.check('isAdmin')"
                  class="m-1"
                ></vs-divider>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout()"
                >
                  <feather-icon
                    icon="LogOutIcon"
                    svgClasses="w-4 h-4"
                  ></feather-icon>
                  <span class="ml-2">Logout</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moment from "moment";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      locale: "TH",
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      notification: [],
      amoutNotifacation: null,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
      username: localStorage.getItem("accessUsername"),
    };
  },
  computed: {
    ...mapState({
      eventNotification: (state) => state.vesselTrip.notificationData,
      isGreenDieselActive: (state) => state.isGreenDieselActive,
      isDomesticOilActive: (state) => state.isDomesticOilActive,
      isExportOilActive: (state) => state.isExportOilActive,
    }),

    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },
    // NAVBAR STYLE
    classObj() {
      let res = "";
      if (this.sidebarWidth == "default") {
        res = "navbar-default";
      } else if (this.sidebarWidth == "reduced") {
        res = "navbar-reduced";
      } else if (this.sidebarWidth) {
        res = "navbar-full";
      }
      return res;
    },
    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },
    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },
    // PROFILE
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    // i18n
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      let res = {};
      if (locale == "en") {
        res.flag = "en";
        res.lang = "English";
      } else if (locale == "th") {
        res.flag = "th";
        res.lang = "Thai";
      }
      return res;
    },
  },
  mounted() {
    this.getEventNotificationsData();
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
    eventNotification(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.getAmoutNotifacation();
      }
    },
    isGreenDieselActive(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.getEventNotificationsData();
      }
    },
    isDomesticOilActive(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.getEventNotificationsData();
      }
    },
    isExportOilActive(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.getEventNotificationsData();
      }
    },
  },
  methods: {
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    async getEventNotificationsData() {
      await this.$store.dispatch("getEventNotificationsData");
      if (this.isGreenDieselActive) {
        this.notification = _.filter(this.eventNotification, [
          "vessel_trip.destination_type",
          'transit',
        ]);
      } else if (this.isDomesticOilActive) {
        this.notification = _.filter(this.eventNotification, (o)=>{
            return o.vessel_trip.destination_type != 'transit' && o.vessel_trip.destination_type != 'export'
        });
      } else if(this.isExportOilActive){
        this.notification = _.filter(this.eventNotification, [
          "vessel_trip.destination_type",
          'export',
        ]);
      } else {
        this.notification = this.eventNotification;
      }
      // console.log(this.isGreenDieselActive,this.eventNotification,this.notification );
      this.getAmoutNotifacation();
    },
    getAmoutNotifacation() {
      this.amoutNotifacation = _.filter(this.notification, {
        read_at: null,
      }).length;
      return this.amoutNotifacation;
    },
    markAllEventNotificationsAsRead(){
      this.$store.dispatch("markAllEventNotificationsAsRead");
    },
    detailNotification(vessel_trip_id,id) {
      this.$store.dispatch("markEventNotificationsAsRead", id);
      localStorage.setItem("vesselTripId", vessel_trip_id);
      this.$router.push("/printNotification");

    },
    logout() {
      localStorage.clear();
      let routeData = this.$router.resolve({ name: "pageLogin" });
      window.open(routeData.href, "_parent");
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `${seconds} sec ago` : "just now");
      }

      return "Just Now";
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    VuePerfectScrollbar,
  },
};
</script>
